class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.isMobile = window.matchMedia("(max-width: 989px)").matches;
    this.form = this.querySelector(".js-facets-form");
    this.apply = this.querySelector(".js-filter-apply");
    this.debouncedOnSubmit = debounce(event => this.onSubmitHandler(event), 500);
    this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));

    this.isMobile ? this.initMobileFilters() : this.initDesktopFilters();

    this.addFakeSelectListener();
  }

  initMobileFilters() {
    const desktop = this.querySelector(".js-filters-desktop");

    desktop.remove();
  }

  initDesktopFilters() {
    const drawer = this.querySelector(".js-filters-drawer");

    drawer.remove();
  }

  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainers = document.querySelectorAll(".js-product-count");

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    if (countContainers.length) countContainers.forEach(element => element.classList.add('loading'));

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {html, url}];
        FacetFiltersForm.renderFunctions(html, event);

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFunctions(html, event);
  }

  static renderFunctions(html, event) {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderDesktopDropdownActiveFacets(html);
    FacetFiltersForm.renderDesktopFooterActiveFacetsBar(html);
    FacetFiltersForm.renderPagination(html);
    FacetFiltersForm.renderSort(html);
    FacetFiltersForm.renderActiveFilterCount(html);
    FacetFiltersForm.renderMobileDrawerHead(html);
  }

  static renderProductGridContainer(html) {
    const gridContainer = html.getElementById('ProductGridContainer');
    const newGridContainer = document.getElementById('ProductGridContainer');

    newGridContainer.innerHTML = gridContainer.innerHTML;
  }

  static renderActiveFilterCount(html) {
    const count = html.querySelector(".js-active-filters");
    const newCount = document.querySelector(".js-active-filters");

    if (count && newCount) newCount.innerHTML = count.innerHTML;

    FacetFiltersForm.updateFilterCountDropdown(html);
  }

  /**
   * Update the count within the filter dropdown to match the count in the active filters section
   * @param {*} html 
   */
  static updateFilterCountDropdown(html) {
     const count = html.querySelector(".js-active-filters");
    const filtersSelected = document.querySelectorAll('[data-filters-selected]');

    if (count && filtersSelected) {
      filtersSelected.forEach(element => {
        const filterSelectdData = element.dataset.filtersSelected;
        if (filterSelectdData) {
          // Remove paraentheses from count.innerHTML
          var countValue = count.innerHTML.replace(/\(|\)/g, '');

          // replace {{count}} with the actual count value from the HTML
          element.innerHTML = filterSelectdData.replace('{{ count }}', countValue);
        } else {
          element.innerHTML = count.innerHTML;
        }
      });
    }
  }

  static renderProductCount(html) {
    const count = html.querySelectorAll(".js-product-count");
    const container = document.querySelectorAll(".js-product-count");

    container.forEach((element, index) => {
      element.classList.remove('loading');
      element.innerHTML = count[index].innerHTML;
    });
  }

  static renderFilters(html, event) {
    const facetDetailsElements = html.querySelectorAll('#FacetFiltersForm .js-filter');

    const matchesIndex = element => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach(element => {
      const facet = element.querySelector(".filters__list");
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      const list = target.querySelector(".filters__list");

      if (list && facet) list.innerHTML = facet.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(html);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".js-refinements", ".js-refinements-mobile"];

    activeFacetElementSelectors.forEach(selector => {
      const activeFacetsElement = html.querySelector(selector);
      const newActiveFacetsElement = document.querySelector(selector)

      if (!activeFacetsElement || !newActiveFacetsElement) return;

      newActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static updateURLHash(searchParams) {
    history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static renderMobileDrawerHead(html) {
    const head = html.querySelector(".js-drawer-head");
    const newHead = document.querySelector(".js-drawer-head");

    if (head && newHead) newHead.innerHTML = head.innerHTML;
  }

  /* Desktop Dropdown Active Facets Information */
  static renderDesktopDropdownActiveFacets(html) {
    const facets = html.querySelector(".js-filters-facets-info");
    const newFacets = document.querySelector(".js-filters-facets-info");

    if (facets && newFacets)  newFacets.innerHTML = facets.innerHTML;
  }

  /* Desktop Active Facets Plus Reset and Label */
  static renderDesktopFooterActiveFacetsBar(html) {
    const footer = html.querySelector(".js-filter-footer");
    const newFooter = document.querySelector(".js-filter-footer");

    if (footer && newFooter) newFooter.innerHTML = footer.innerHTML;
  }

  static renderPagination(html) {
    const pagination = html.querySelector('.js-pagination');
    const newPagination = document.querySelector('.js-pagination');

    if (pagination) newPagination.replaceWith(pagination);
  }

  static renderSort(html) {
    const options = html.querySelectorAll(".js-select .js-select-item");
    const newOptions = document.querySelectorAll(".js-select .js-select-item");
    const selectedOption = Array.from(options).find(option => option.classList.contains("select__item--active"));

    newOptions.forEach(option => {
      const selectedValue = selectedOption.dataset.value;
      const value = option.dataset.value;

      option.classList.remove("select__item--active");

      if (selectedValue === value) option.classList = selectedOption.classList;
    });
  }

  static getSections() {
    return [{ section: document.getElementById('product-grid').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = document.querySelector('facet-filters-form form');
    const noJsElements = document.querySelectorAll('.no-js-list');

    noJsElements.forEach(el => el.remove());

    this.onSubmitForm(this.createSearchParams(form), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const href = event.currentTarget.href;
    const url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }

  addFakeSelectListener() {
    const selects = this.querySelectorAll(".select");

    selects.forEach(select => {
      const options = select.querySelectorAll(".select__item");
      const label = select.querySelector(".select__label");

      if (label) label.addEventListener("click", event => {
        event.stopPropagation();

        select.classList.toggle("select--active");
      });

      options.forEach(option => option.addEventListener("click", event => {
        this.updateSelect(event);

        select.classList.remove("select--active");
      }));

      window.addEventListener("click", event => {
        if (!select.contains(event.target) && select?.classList.contains("select--active")) {
          select.classList.remove("select--active");
        }
      });
    });
  }

  updateSelect(event) {
    const container = event.target.closest(".select");
    const select = container.querySelector(".select__select");
    const options = Array.from(select.querySelectorAll("option"));
    const selected = event.target.dataset.value;
    const selectedOption = options.find(option => option.value === selected);

    if (selectedOption) select.value = selectedOption.value;

    this.onSubmitHandler(event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();

customElements.define('facet-filters-form', FacetFiltersForm);

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('facet-filters-form');

    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
